<template>
  <div>
    <nav-bar />
    <b-row style="margin: 0px;">
      <b-col style="padding: 0px;">
        <nav-drawer />
      </b-col>
      <b-col cols="10" style="padding: 0px;">
        <router-view />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import NavBar from '@/views/layouts/components/NavBar.vue'
import NavDrawer from '@/views/layouts/components/NavDrawer.vue'

export default {
  name: 'AdminLayout',
  data () {
    return {}
  },
  components: {
    NavBar,
    NavDrawer
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layouts/AdminLayout.vue